import { Class, StudentInfo } from "models";
import { atom } from "recoil";

export const SchoolIDState = atom<string>({
  key: "global/schoolID",
  default: ""
})

export const ClassIDState = atom<string>({
  key: "global/classID",
  default: ""
})

export const StudentIDState = atom<string>({
  key: "global/studentID",
  default: "",
});

export const StudentInfoState = atom<StudentInfo | undefined>({
  key: "global/studentInfo",
  default: undefined,
});

export const SchoolClassesState = atom<Class[]>({
  key: "global/classes",
  default: []
})

export const ClassStudentsState = atom<StudentInfo[]>({
  key: "global/students",
  default: []
})